/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React from 'react';
import { Box, MenuItem, Typography } from '@mui/material';
import MaterialSymbol from '../../../components/MaterialSymbol';
import { useSelector } from 'react-redux';
import { selectCurrentCart } from '../storage/cart.slice';
import { copyTextToClipboard } from '../../../util/copyToClipboard';
import { selectCurrentFarmerAccount } from '../../azure-b2c/storage';
import { Button } from '../../../components/Button';

export const MenuEntry = ({ label, onClick }: { label: string; onClick: () => void }) => (
  <MenuItem onClick={onClick}>
    <Typography variant='body2'>{label}</Typography>
  </MenuItem>
);

export const TFOCartMenu = () => {
  const cart = useSelector(selectCurrentCart);
  const account = useSelector(selectCurrentFarmerAccount);

  const buildCartUrl = () => {
    const items = cart?.items;

    if (items) {
      let baseUrl = process.env.REACT_APP_AZURE_B2C_LOGIN_REDIRECT_URI;
      // Make sure we don't double up the end slash.
      if (baseUrl?.endsWith('/')) {
        baseUrl = baseUrl.substring(0, baseUrl.length - 1);
      }
      const ids = items.map((item) => item.productId).join(',');
      const qtys = items.map((item) => item.quantity).join(',');
      const sizes = items.map((item) => item.size).join(',');
      const colors = items.map((item) => item.colour).join(',');
      const url = `${baseUrl}/products/cart?ids=${ids}&qtys=${qtys}&sizes=${sizes}&colors=${colors}`;

      copyTextToClipboard(url);
      return url;
    }
  };

  if (account?.hasTfoAccess) {
    return (
      <Button
        onClick={buildCartUrl}
        variant='text'
        sx={{ textDecoration: 'none', height: '90%', mr: '-8px' }}
        endIcon={
          <Box
            aria-label='Cart options menu'
            color='primary'
            sx={{ pt: 0.5, margin: 'auto', textDecoration: 'none !important', fontWeight: 400 }}
          >
            <MaterialSymbol>link</MaterialSymbol>
          </Box>
        }
      >
        Copy cart to clipboard
      </Button>
    );
  }
};
